import React from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";

const type = [
  {
    id: "Desktop",
    label: "Desktop",
    value: 210,
    color: "#3174A0",
  },
  {
    id: "Tablet",
    label: "Tablet",
    value: 120,
    color: "#49A397",
  },
  {
    id: "Server",
    label: "Server",
    value: 40,
    color: "#ECC353",
  },
  {
    id: "Laptop",
    label: "Laptop",
    value: 120,
    color: "#9DBE4C",
  },
  {
    id: "Others",
    label: "Others",
    value: 30,
    color: "#395378",
  },
];

const DeviceType = ({ typeSummary, onFilterSelect, className }) => {
  let total = 0;

  const newType = type.map((type) => {
    type.value = typeSummary[type.id] || 0;
    total += type.value;
    return type;
  });

  return (
    <InfoBox
      header={"Device Type "}
      headerProps={{ style: { color: "#111111" } }}
      className={className}
    >
      <DonutChart
        data={newType}
        legend
        centerText={`${total} Devices`}
        size="12rem"
        legendPadding="0.4rem 2rem 0.4rem 0.4rem"
        onDatumClick={onFilterSelect}
      />
    </InfoBox>
  );
};

export default DeviceType;
